import { render } from "./BattleMain.vue?vue&type=template&id=a511fed0"
import script from "./BattleMain.vue?vue&type=script&lang=js"
export * from "./BattleMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__